// extracted by mini-css-extract-plugin
export var downArrow = "_av-0";
export var infoTooltipIcon = "_av-3";
export var label = "_av-1";
export var optionCard = "_av-4";
export var upArrow = "_av-2";